import { render } from "./ClientiSearchResult.vue?vue&type=template&id=4b55a617&ts=true"
import script from "./ClientiSearchResult.vue?vue&type=script&lang=ts"
export * from "./ClientiSearchResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__